import { END_POINT } from "constants/apiConstant";
import { apiPost } from "../utils/apiUtils";

const { TI_ORDER_CREATE, TI_ORDER_RETRIEVE } = END_POINT;

// Place a TI store order. Shipping/billing/payment come from the checkout
// profile held on the company's TI account, so only line items are sent.
export const createTiOrder = async (payload) => {
  return await apiPost(TI_ORDER_CREATE, payload);
};

// Look up a TI order live by its TI order number.
export const retrieveTiOrder = async (orderNumber) => {
  return await apiPost(TI_ORDER_RETRIEVE, { order_number: orderNumber });
};
